import type { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type { ComponentProps } from 'react';
import { USER_ACCOUNT_QUERY_KEY } from './clients/gateway-client/gatewayClient';

type PersistOptions = ComponentProps<typeof PersistQueryClientProvider>['persistOptions'];
type ShouldDehydrateQuery = NonNullable<
	NonNullable<PersistOptions['dehydrateOptions']>['shouldDehydrateQuery']
>;
type PersistableQuery = Parameters<ShouldDehydrateQuery>[0];

const isUserAccountQuery = (queryKey: readonly unknown[]): boolean =>
	queryKey.length === 1 && queryKey[0] === USER_ACCOUNT_QUERY_KEY;

// Exclude the authenticated user account query from persisted React Query state so protected UI
// cannot hydrate from stale identity data after a session expires. Preserve TanStack's default
// persistence behavior for all other queries by only dehydrating successful query results.
export const shouldDehydratePersistedQuery: ShouldDehydrateQuery = (
	query: PersistableQuery,
): boolean => {
	if (isUserAccountQuery(query.queryKey)) {
		return false;
	}

	return query.state.status === 'success';
};
